import { memo } from 'react';

// NB - we may need to extend the vocabulary for meta and links. E.g. if we want to pass
// icon sizes. Same goes if we want to set other tags.

// Note that we set headers for both caching and security in cloudfront functions

// React 19 natively hoists <title>, <meta>, and <link> tags to <head>

interface MetaLink {
    rel: string;
    href: string;
}

interface MetaTag {
    name?: string;
    property?: string;
    content: string;
}

function Metadata({ title = '', links = [], metas = [] }: { title?: string; links?: MetaLink[]; metas?: MetaTag[] }) {
    return (
        <>
            {title && <title>{title}</title>}
            {links.map((link) => (
                <link key={link.href} rel={link.rel} href={link.href} />
            ))}
            {metas.map((meta) => (
                <meta key={meta.name || meta.property} name={meta.name} property={meta.property} content={meta.content} />
            ))}
        </>
    );
}

export default memo(Metadata);
